<template>
  <div class="flex justify-center">
    <div v-if="link" class="d-flex justify-center">
      <a
        class="white--text tp-text-subtitle-semibold-white"
        data-cy="sms-phone-modal-trigger-link"
        @click="openModal"
      >
        {{ triggerLabel }}
      </a>
    </div>
    <Button
      v-else
      gray
      no-shadow
      data-cy="sms-phone-modal-trigger-button"
      @click="openModal"
    >
      {{ triggerLabel }}
    </Button>
    <Modal
      :is-open="modalOpen"
      :title="$t('screens.payInPersonSuccess.smsDisclaimerTitle')"
      :subtitle="$t('screens.payInPersonSuccess.smsDisclaimer')"
      :cta-label="$t('generic.enable')"
      :close-label="$t('generic.notNow')"
      :cta-disabled="!isValid || isSubmitting"
      :cta-loading="isSubmitting"
      :show-close-button="true"
      @cta-click="onSubmit"
      @close-click="closeModal"
    >
      <template slot="image">
        <div class="d-flex justify-center align-center">
          <img
            class="pb-12 pt-4"
            :src="require('@/assets/images/icons/notification-bell.svg')"
          />
        </div>
      </template>
      <template slot="content">
        <div ref="phoneInputWrapper" class="phone-input pt-6">
          <vue-phone-number-input
            ref="phoneInput"
            v-model="phoneNumber"
            no-flags
            :color="'#000000'"
            :default-country-code="locale"
            size="lg"
            :translations="{
              countrySelectorLabel: $t(
                'components.notificationModal.countrySelectorLabel'
              ),
              countrySelectorError: $t(
                'components.notificationModal.countrySelectorError'
              ),
              phoneNumberLabel: $t(
                'components.notificationModal.phoneNumberLabel'
              ),
              example: $t('components.notificationModal.example'),
            }"
            no-example
            @update="onNumberChange"
          />
          <div class="tp-text-label black--text mt-4">
            <span>
              {{ $t('screens.order.notificationsModalBodySMS') }}
            </span>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/common/Modal.vue';
import Button from '@/components/Button.vue';

export default {
  name: 'SmsPhoneModalTrigger',
  components: {
    Modal,
    Button,
  },
  props: {
    session: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      default: null,
    },
    link: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modalOpen: false,
      phoneNumber: null,
      nationalNumber: null,
      countryCallingCode: null,
      isValid: false,
      isSubmitting: false,
    };
  },
  computed: {
    triggerLabel() {
      return this.buttonText || this.$t('screens.payInPersonSuccess.smsCta');
    },
    locale() {
      const localeCode = this.$store.state.locale?.locale_code || 'lt-LT';
      return localeCode.split('-')[1];
    },
  },
  methods: {
    openModal() {
      this.modalOpen = true;
      this.$emit('open');
      setTimeout(() => {
        if (typeof window === 'undefined') {
          return;
        }

        const wrapper = this.$refs.phoneInputWrapper;
        if (!wrapper) return;

        const phoneInputComponent = this.$refs.phoneInput;
        const input =
          phoneInputComponent?.$el?.querySelector('input[type="tel"]') ||
          wrapper.querySelector('input[type="tel"]') ||
          phoneInputComponent?.$el?.querySelector('input') ||
          wrapper.querySelector('input');

        if (!input) return;

        input.focus();

        // After the keyboard opens, scroll the input into view (modal scroll)
        setTimeout(() => {
          if (typeof input.scrollIntoView === 'function') {
            input.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
            return;
          }

          const scrollContainer =
            input.closest('.v-dialog__content') ||
            input.closest('.v-overlay__content') ||
            input.closest('.v-dialog') ||
            wrapper;

          if (!scrollContainer) return;
          scrollContainer.scrollTop = (scrollContainer.scrollTop || 0) + 200;
        }, 500);
      }, 100);
    },
    closeModal() {
      this.modalOpen = false;
      this.$emit('close');
    },
    onNumberChange({ isValid, countryCallingCode, nationalNumber }) {
      this.countryCallingCode = countryCallingCode;
      this.isValid = isValid;
      this.nationalNumber = nationalNumber;
    },
    async onSubmit() {
      if (!this.countryCallingCode || !this.nationalNumber || !this.isValid) {
        return;
      }
      this.isSubmitting = true;
      try {
        await this.axios.post(`/session/${this.session}/add-phone-number`, {
          countryCallingCode: this.countryCallingCode,
          nationalNumber: this.nationalNumber,
        });
        this.$store.dispatch(
          'setSessionPhoneNumber',
          `+${this.countryCallingCode}${this.nationalNumber}`
        );
        this.closeModal();
        this.$emit('success', {
          countryCallingCode: this.countryCallingCode,
          nationalNumber: this.nationalNumber,
        });
      } catch (error) {
        console.error('Failed to save phone number:', error);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.phone-input::v-deep {
  .country-selector {
    .country-selector__list__item {
      font-size: 16px !important;
    }

    &__list {
      z-index: 333;
      height: 150px !important;
    }
  }

  .vue-phone-number-input {
    input {
      font-size: 16px !important;
    }
  }
}
</style>
